import {Component, Input, ViewChild} from '@angular/core';
import {G2Review} from '../../../models/g2-review.model';
import {LimitedHtmlComponent} from '@app/shared/limited-html/limited-html.component';
import {StarRatingComponent} from '../star-rating/star-rating.component';
import {LimitedHtmlComponent as LimitedHtmlComponent_1} from '../../../../shared/limited-html/limited-html.component';
import {ReviewAnswersComponent} from '../review-answers/review-answers.component';
import {DatePipe} from '@angular/common';
import {TranslatePipe} from '@spartacus/core';

@Component({
  selector: 'dcp-review-preview',
  templateUrl: './review-preview.component.html',
  styleUrls: ['./review-preview.component.scss'],
  imports: [StarRatingComponent, LimitedHtmlComponent_1, ReviewAnswersComponent, DatePipe, TranslatePipe],
})
export class ReviewPreviewComponent {
  @ViewChild(LimitedHtmlComponent) limitedHtmlComponent: LimitedHtmlComponent;
  @Input() review: G2Review;
  @Input() reviewAnswerOrder: string[];
  @Input() limitedHtmlSiblings: LimitedHtmlComponent[];
}
